// extracted by mini-css-extract-plugin
export var root = "CapsAndTech-module--root--2Zjrx";
export var beforeTitle = "CapsAndTech-module--beforeTitle--1-Sfd";
export var title = "CapsAndTech-module--title--mt6zF";
export var left = "CapsAndTech-module--left--3PoD4";
export var right = "CapsAndTech-module--right--Al3ke";
export var content = "CapsAndTech-module--content--1jeOj";